import mainLogo from '../assets/img/home/logo.png';

// icon
import profileIcon from '../assets/img/home/icons/profile.svg';
import starIcon from '../assets/img/home/icons/star.svg';
import closeIcon from '../assets/img/home/icons/close.png';
import locationIcon from '../assets/img/home/icons/location.png';

import addIcon from '../assets/img/admin_dashboard/add.svg';
import deleteIcon from '../assets/img/admin_dashboard/delete.svg';
import icoImage from '../assets/img/admin_dashboard/ico-image.png'

import basicInfo from '../assets/img/add-event/basic-info.png';
import calendar from '../assets/img/add-event/calendar.png';
import description from '../assets/img/add-event/description.png';
import location from '../assets/img/add-event/location2.png';
import uploadImage from '../assets/img/add-event/upload-image.png';

import onlineEventImg from '../assets/img/home/events/Online_Event.png';
import otherEventImg from '../assets/img/home/events/Other_Event.png';
import pageBanner from '../assets/img/page_banner.png';

import hopeTown from '../assets/img/user_events/hope-town.jpg';
import nicaStory from '../assets/img/user_events/nica-story.jpg';
import faithBanner from '../assets/img/user_events/faith-banner.png'
import ssoIcon from '../assets/img/user_events/SSO.png'
import googleIcon from '../assets/img/user_events/google.png'
import facebookIcon from '../assets/img/user_events/facebook.png'

import downloadIcon from '../assets/img/download.svg'
import uploadIcon from '../assets/img/upload.svg'

import editIcon from '../assets/img/user_profile/edit.svg'

import arrowIcon from '../assets/img/home/icons/arrow.svg'

const images = {
    mainLogo,
    profileIcon,
    starIcon,
    closeIcon,
    locationIcon,
    onlineEventImg,
    otherEventImg,
    pageBanner,

    hopeTown,
    nicaStory,
    faithBanner,
    ssoIcon,
    googleIcon,
    facebookIcon,
    addIcon,
    deleteIcon,
    icoImage,

    basicInfo,
    calendar,
    description,
    location,
    uploadImage,

    downloadIcon,
    uploadIcon,
    editIcon,
    arrowIcon
}

export default images